import { useRecoilState } from 'recoil';

export function useTimers(atom) {
    const [timers_state, set_new_timers_state] = useRecoilState(atom);
    const edit_timers = (timer, value) => {
        let state = { ...timers_state, [timer]: value }
        set_new_timers_state(state)
    }
    return { timers_state, set_new_timers_state, edit_timers }
}